import React, { Component } from "react";
import "./App.css";
import { HashRouter, Route, Switch } from "react-router-dom";
import "fontsource-roboto";
import LoginForm from "./containers/LoginForm";
import EnterSitePage from "./containers/EnterSitePage";

import ExpiredPage from "./containers/ExpiredPage";

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact={true} path="/" component={LoginForm} />

          <Route exact={true} path="/expired" component={ExpiredPage} />
          <Route exact={true} path="/enter" component={EnterSitePage} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
